import { ChangeDetectionStrategy, Component, Input, OnInit, computed, inject } from '@angular/core';

import { Observable, distinctUntilChanged, filter, map } from 'rxjs';

import { FinnairThemeService } from '@fcom/common';
import { FinnairTheme } from '@fcom/common/interfaces/theme.interface';
import { CmsCollection, CmsContent } from '@fcom/core-api/interfaces/cms-interface';
import { isNotEmpty, safeMap } from '@fcom/core/utils';

@Component({
  selector: 'cms-unique-selling-point',
  styleUrls: ['./cms-unique-selling-point.component.scss'],
  templateUrl: './cms-unique-selling-point.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CmsUniqueSellingPointComponent implements OnInit {
  private themeService = inject(FinnairThemeService);

  readonly isNewBrand = computed(() => this.themeService.siteTheme() !== FinnairTheme.LEGACY);

  @Input()
  content$: Observable<CmsCollection>;
  items$: Observable<CmsContent[]>;

  ngOnInit(): void {
    this.items$ = this.content$.pipe(
      map((content: CmsCollection) => safeMap(content, (c: CmsCollection) => c.items)),
      filter(isNotEmpty),
      distinctUntilChanged()
    );
  }
}
